import { defineMessages } from 'react-intl'

export const routeSubformMessages = defineMessages({
  back: {
    id: 'routeSubform.back',
    defaultMessage: 'Takaisin',
  },
  startLocation: {
    id: 'routeSubform.startLocation',
    defaultMessage: 'Lähtöpaikka',
  },
  endLocation: {
    id: 'routeSubform.endLocation',
    defaultMessage: 'Lopetuspaikka',
  },
  station: {
    id: 'routeSubform.station',
    defaultMessage: 'Asemapaikka',
  },
  other: {
    id: 'routeSubform.other',
    defaultMessage: 'Muu',
  },
  startRouteStationGroup: {
    id: 'routeSubform.startRouteStationGroup',
    defaultMessage: 'Kuormakirjan lähtöpaikka',
  },
  endRouteStationGroup: {
    id: 'routeSubform.endRouteStationGroup',
    defaultMessage: 'Kuormakirjan lopetuspaikka',
  },
  time: {
    id: 'routeSubform.time',
    defaultMessage: 'Aika',
  },
  address: {
    id: 'routeSubform.address',
    defaultMessage: 'Osoite',
  },
  city: {
    id: 'routeSubform.city',
    defaultMessage: 'Kaupunki',
  },
  destinationAddress: {
    id: 'routeSubform.destinationAddress',
    defaultMessage: 'Kohdeosoite',
  },
  estimatedArrivalTime: {
    id: 'routeSubform.estimatedArrivalTime',
    defaultMessage: 'Arvioitu saapumisaika',
  },
  calculate: {
    id: 'routeSubform.calculate',
    defaultMessage: 'Laske',
  },
  unitLocation: {
    id: 'routeSubform.unitLocation',
    defaultMessage: 'Yksikön sijainti',
  },
  startTime: {
    id: 'routeSubform.startTime',
    defaultMessage: 'Aloitusaika',
  },
  arrivalTime: {
    id: 'routeSubform.arrivalTime',
    defaultMessage: 'Saapumisaika',
  },
  additionalInfo: {
    id: 'routeSubform.additionalInfo',
    defaultMessage: 'Lisäselvitykset',
  },
  destination: {
    id: 'routeSubform.destination',
    defaultMessage: 'Kohde',
  },
  atDestination: {
    id: 'routeSubform.atDestination',
    defaultMessage: 'Kohteessa',
  },
  estimatedWorkDuration: {
    id: 'routeSubform.estimatedWorkDuration',
    defaultMessage: 'Arvioitu työnkesto',
  },
  estimatedCompletionTime: {
    id: 'routeSubform.estimatedCompletionTime',
    defaultMessage: 'Arvioitu valmistumisaika',
  },
  action: {
    id: 'routeSubform.action',
    defaultMessage: 'Toimenpide',
  },
  reason: {
    id: 'routeSubform.reason',
    defaultMessage: 'Syy',
  },
  fault: {
    id: 'routeSubform.fault',
    defaultMessage: 'Vika',
  },
  completionTime: {
    id: 'routeSubform.completionTime',
    defaultMessage: 'Valmistumisaika',
  },
  odometerReading: {
    id: 'routeSubform.odometerReading',
    defaultMessage: 'Mittarilukema, km',
  },
  deliveredBattery: {
    id: 'routeSubform.deliveredBattery',
    defaultMessage: 'Toimitettu akku',
  },
  customerPaymentMethod: {
    id: 'routeSubform.customerPaymentMethod',
    defaultMessage: 'Asiakkaan maksutapa',
  },
  deliveredBatteryOther: {
    id: 'routeSubform.deliveredBatteryOther',
    defaultMessage: 'Toimitettu akku, muu',
  },
  keyDropOffLocation: {
    id: 'routeSubform.keyDropOffLocation',
    defaultMessage: 'Avainten jättöpaikka',
  },
  fillOnlyCompletionTime: {
    id: 'routeSubform.fillOnlyCompletionTime',
    defaultMessage: 'Täytä vain valmistumisaika',
  },
  setRepairShop: {
    id: 'routeSubform.setRepairShop',
    defaultMessage: 'Aseta korjaamo',
  },
  loadingRepairShop: {
    id: 'routeSubform.loadingRepairShop',
    defaultMessage: 'Ladataan korjaamoa',
  },
  repairShop: {
    id: 'routeSubform.repairShop',
    defaultMessage: 'Korjaamo',
  },
  changeRepairShop: {
    id: 'routeSubform.changeRepairShop',
    defaultMessage: 'Vaihda korjaamoa',
  },
  towingReason: {
    id: 'routeSubform.towingReason',
    defaultMessage: 'Hinauksen syy',
  },
  workType: {
    id: 'routeSubform.workType',
    defaultMessage: 'Työn tyyppi',
  },
  notes: {
    id: 'routeSubform.notes',
    defaultMessage: 'Muistiinpanot (Ei näy asiakkaalle)',
  },
  changeRepairShopModalTitle: {
    id: 'routeSubform.changeRepairShopModalTitle',
    defaultMessage: 'Vaihda korjaamoa',
  },
  changeRepairShopModalWarning: {
    id: 'routeSubform.changeRepairShopModalWarning',
    defaultMessage: 'HUOM! Korjaamon vaihto voi vaikuttaa työn korvattavuuteen.',
  },
  selectNewRepairShop: {
    id: 'routeSubform.selectNewRepairShop',
    defaultMessage: 'Valitse uusi korjaamo',
  },
  selectRepairShop: {
    id: 'routeSubform.selectRepairShop',
    defaultMessage: 'Valitse korjaamo',
  },
  otherAddress: {
    id: 'routeSubform.otherAddress',
    defaultMessage: 'Muu osoite',
  },
  cancel: {
    id: 'routeSubform.cancel',
    defaultMessage: 'Peru',
  },
  attention: {
    id: 'routeSubform.attention',
    defaultMessage: 'Huomio',
  },
  cancelModal: {
    id: 'routeSubform.cancelModal',
    defaultMessage: 'Peruuta',
  },
  edit: {
    id: 'routeSubform.edit',
    defaultMessage: 'Muokkaa',
  },
  roadServiceWarningMessage: {
    id: 'routeSubform.roadServiceWarningMessage',
    defaultMessage:
      'Valitsemalla toimenpiteeksi tiepalvelun, määränpään reittipisteen tiedot tyhjennetään tallennuksen yhteydessä.',
  },
  nonTowingServiceWarningMessage: {
    id: 'routeSubform.nonTowingServiceWarningMessage',
    defaultMessage:
      'Valitsemalla toimenpiteeksi muun kuin hinauspalvelu, määränpään reittipisteen tiedot tyhjennetään tallennuksen yhteydessä.',
  },
  saveDeparture: {
    id: 'routeSubform.saveDeparture',
    defaultMessage: 'Tallenna lähtö',
  },
  saveDepartureMobile: {
    id: 'routeSubform.saveDepartureMobile',
    defaultMessage: 'Tallenna',
  },
  destinationLabel: {
    id: 'routeSubform.destinationLabel',
    defaultMessage: 'Määränpää',
  },
  jobDoneLabel: {
    id: 'routeSubform.jobDoneLabel',
    defaultMessage: 'Työ valmis',
  },
  errorTitle: {
    id: 'routeSubform.errorTitle',
    defaultMessage: 'Virhe',
  },
  errorSelectStation: {
    id: 'routeSubform.errorSelectStation',
    defaultMessage: 'Valitse asemapaikka',
  },
  saveEnd: {
    id: 'routeSubform.saveEnd',
    defaultMessage: 'Tallenna lopetus',
  },
  saveArrived: {
    id: 'routeSubform.saveArrived',
    defaultMessage: 'Tallenna saapunut',
  },
  saveFinished: {
    id: 'routeSubform.saveFinished',
    defaultMessage: 'Tallenna valmis',
  },
  saveAtDestination: {
    id: 'routeSubform.saveAtDestination',
    defaultMessage: 'Tallenna kohteessa',
  },
  repairShopName: {
    id: 'routeSubform.repairShopName',
    defaultMessage: 'Korjaamon nimi',
  },
  arrivedAtBreakdownLocationHeader: {
    id: 'routeSubform.arrivedAtBreakdownLocationHeader',
    defaultMessage: 'SAAPUNUT KOHTEESEEN',
  },
  clear: {
    id: 'routeSubform.clear',
    defaultMessage: 'Tyhjennä',
  },
  routeTimeValidationError: {
    id: 'routeSubform.routeTimeValidationError',
    defaultMessage: '{routeType} aikaleiman tulee olla ennen nykyistä reittipistettä',
  },
  routeTypeStart: {
    id: 'routeSubform.routeTypeStart',
    defaultMessage: 'Lähtöpaikan',
  },
  routeTypeArrival: {
    id: 'routeSubform.routeTypeArrival',
    defaultMessage: 'Kohteen',
  },
  routeTypeFinish: {
    id: 'routeSubform.routeTypeFinish',
    defaultMessage: 'Työ valmis',
  },
  routeTypeFinishBreakdownLocation: {
    id: 'routeSubform.routeTypeFinishBreakdownLocation',
    defaultMessage: 'Valmis kohteessa',
  },
  routeTypeFinishDestination: {
    id: 'routeSubform.routeTypeFinishDestination',
    defaultMessage: 'Valmis määränpäässä',
  },
  destinationCoordsMissingError: {
    id: 'routeSubform.destinationCoordsMissingError',
    defaultMessage:
      'Määränpään koordinaatteja ei saatu haettua. Hae osoite kartalta tai valitse osoite osoitehaun ehdotuksista.',
  },
})
